import { render, staticRenderFns } from "./SearchKeyword.vue?vue&type=template&id=0b13f8bb"
import script from "./SearchKeyword.vue?vue&type=script&lang=js"
export * from "./SearchKeyword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports